import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'
import proxyClient from '@/plugins/axios/proxyClient'

export default {
  /**
   *
   * @param {
   *   loanType: 'normal', 옵션
   *   repaymentPeriodInDays: 5, 30, 180  // 옵션
   * } query
   * @returns
   */
  getLoansOffersCurrent(query = {}) {
    return defaultClient.get(`/loans/offers/current/?${qs.stringify(query)}`)
  },
  postLoansOfferEarlyPayment() {
    return defaultClient.post('/loans/offers/early_payment/')
  },
  postLoansCreate(offerId) {
    return defaultClient.post('/loans/create/', {
      offer: offerId,
    })
  },
  getLoansExecuteFunding() {
    return defaultClient.get('/loans/execute-funding/')
  },
  getRepaymentsSimple(query) {
    return defaultClient.get(`/loans/repayments-simple?${qs.stringify(query)}`)
  },
  postLoan(offerId) {
    return defaultClient.post('/loans/create/', {
      offer: offerId,
    })
  },
  getLoans(query) {
    return defaultClient.get(`/loans/?${qs.stringify(query)}`)
  },
  getCurrentLoan() {
    return defaultClient.get('/loans/current/')
  },
  getLoansDetail(uuid) {
    return defaultClient.get(`/loans/${uuid}/`)
  },
  getLoansRepayments(uuid) {
    return defaultClient.get(`/loans/repayments/?${qs.stringify({ uuid })}`)
  },
  getLoansRegisterFunding(uuid) {
    return defaultClient.get(`/loans/register-funding/?${qs.stringify({ uuid })}`)
  },
  getInvestingAmount(uuid) {
    return defaultClient.get(`/loans/investing-amount/?${qs.stringify({ uuid })}`)
  },
  getCloseFunding(uuid) {
    return defaultClient.get(`/loans/close-funding/?${qs.stringify({ uuid })}`)
  },
  geExecuteFunding(uuid) {
    return defaultClient.get(`/loans/execute-funding/?${qs.stringify({ uuid })}`)
  },
  getLoanOffer(uuid) {
    return defaultClient.get(`/loans/offers/${uuid}`)
  },
  getLoanAvailableTime() {
    return defaultClient.get(`/loans/available/time/`)
  },

  /**
   * 대출 uuid 로 대출신청정보 조회
   * @param {*} uuid
   * @returns
   */
  getLoansRequestByLoan(uuid) {
    return proxyClient.get(`/loans/${uuid}/request`)
  },

  postSurveyResponse(surveyData) {
    return defaultClient.post('/surveys/responses/', {
      title: '비상금론 펀딩 수수료 환급을 위한 설문',
      response: surveyData.responses,
      has_privacy_consent: surveyData.agreement,
      consented_items: ['이름', '상점명', '사업자등록번호', '전화번호'],
    })
  },

  postLoansProcessRequest(requestUuid) {
    return defaultClient.post(`/loans/process-request/?request_uuid=${requestUuid}`)
  },
}
